import useGetApi from 'src/api/useGetApi';

export interface ExtractionResultDTO {
  id: string;
  status: string;
  isSelected: boolean;
  modelUsed: string;
  modelParameters: Record<string, unknown> | null;
  classificationId: string | null;
  stagedPurchaseOrderId: string | null;
  errorDetails: Record<string, unknown> | null;
  extractedData: Record<string, unknown> | null;
  rawInput: Record<string, unknown> | null;
  rawOutput: Record<string, unknown> | null;
  zodSchemaDefinition: Record<string, unknown> | null;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date | null;
  classification?: {
    id: string;
    classificationResult: string;
    confidenceScore: number;
    isSelected: boolean;
    modelUsed: string;
  } | null;
}

interface ResponseDTO {
  inboundEmailId: string;
  extractions: ExtractionResultDTO[];
}

const useExtractedPurchaseOrder = (inboundEmailId: string, enabled = true) => {
  return useGetApi<ResponseDTO>({
    endpoint: `communications/inbound-emails/${inboundEmailId}/purchase-order-extractions`,
    options: {
      enabled,
    },
  });
};

export default useExtractedPurchaseOrder;
